import { render, screen } from '@testing-library/react'
import WhatWeDoPage from './WhatWeDoPage'

describe('WhatWeDoPage', () => {
  test('renders the page as an accessible region with its main heading', () => {
    render(<WhatWeDoPage />)

    expect(screen.getByRole('region', { name: 'Qué hacemos' })).toBeTruthy()
    expect(screen.getByRole('heading', { name: 'Qué hacemos' })).toBeTruthy()
  })

  test('renders a link to the memories section under collaborations', () => {
    render(<WhatWeDoPage />)

    const link = screen.getByRole('link', {
      name: /Puedes consultar el detalle completo de nuestras actividades y colaboraciones año a año en la sección 'Memorias'/i
    })

    expect(link.getAttribute('href')).toBe('/memorias')
  })
})
